import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.jsx";
import RootLayout from "./layouts/RootLayout.jsx";
import HomePage from "./pages/HomePage.jsx";
import ServiceDetailPage from "./pages/ServiceDetailPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import PricingPage from "./pages/PricingPage.jsx";
import MarketsPage from "./pages/MarketsPage.jsx";
import ContractsIndexPage from "./pages/ContractsIndexPage.jsx";
import ContractTemplatePage from "./pages/ContractTemplatePage.jsx";
import OperatorPlanPage from "./pages/OperatorPlanPage.jsx";
import ReceptionistPage from "./pages/ReceptionistPage.jsx";
import AiChatPage from "./pages/AiChatPage.jsx";
import UnifiNetworksPage from "./pages/UnifiNetworksPage.jsx";
import CustomSitesPage from "./pages/CustomSitesPage.jsx";
import ServiceAreaPage from "./pages/ServiceAreaPage.jsx";
import { coronaServices } from "./content/coronaServices.js";
import LegalPage from "./pages/LegalPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<RootLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/services/receptionist"
            element={<Navigate to="/receptionist" replace />}
          />
          <Route
            path="/services/ai-chat"
            element={<Navigate to="/ai-chat" replace />}
          />
          <Route
            path="/services/unifi-networks"
            element={<Navigate to="/unifi-networks" replace />}
          />
          <Route
            path="/services/custom-sites"
            element={<Navigate to="/custom-sites" replace />}
          />
          {/* Corona, CA service-area pages (static slugs outrank :slug). */}
          {coronaServices.map((svc) => (
            <Route
              key={svc.slug}
              path={`/services/${svc.slug}`}
              element={<ServiceAreaPage slug={svc.slug} />}
            />
          ))}
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/receptionist" element={<ReceptionistPage />} />
          <Route path="/ai-chat" element={<AiChatPage />} />
          <Route path="/unifi-networks" element={<UnifiNetworksPage />} />
          <Route path="/custom-sites" element={<CustomSitesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/markets" element={<MarketsPage />} />
          <Route path="/contracts" element={<ContractsIndexPage />} />
          <Route path="/contracts/:slug" element={<ContractTemplatePage />} />
          <Route path="/privacy" element={<LegalPage slug="privacy" />} />
          <Route path="/terms" element={<LegalPage slug="terms" />} />
          <Route
            path="/internal/operator-plan"
            element={<OperatorPlanPage />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
